const toastMixin = {
  methods: {
    showError(message, options) {
      const notification = {
        type: "error",
        message
      };
      if (options && options.timeout) {
        notification.timeout = options.timeout;
      }
      this.$store.commit("setNotification", notification);
    },
    showSuccess(message, options) {
      const notification = {
        type: "success",
        message
      };
      if (options && options.timeout) {
        notification.timeout = options.timeout;
      }
      this.$store.commit("setNotification", notification);
    },
    showWarning(message, options) {
      const notification = {
        type: "warning",
        message
      };
      if (options && options.timeout) {
        notification.timeout = options.timeout;
      }
      this.$store.commit("setNotification", notification);
    }
  }
};

export default toastMixin;
